module.exports = __webpack_public_path__ + "static/media/explore-image1.0423a068.png";